import { ProjectMemoScreen } from '../../memo'
import { useProjectId } from './params'
import { ModulePage, ModuleSkeleton } from './ui'

/**
 * 项目备忘录页签：同一个 Memo 引擎，作用域从路由来。
 * 不另写一套输入框——主干备忘录屏才是这份契约的渲染方。
 */
export function ProjectMemosPage() {
  const projectId = useProjectId()
  if (!projectId) {
    return (
      <ModulePage testid="project-module-memos">
        <ModuleSkeleton />
      </ModulePage>
    )
  }
  return (
    <div data-testid="project-module-memos" className="flex min-h-0 min-w-0 flex-1 flex-col">
      <ProjectMemoScreen projectId={projectId} />
    </div>
  )
}

export { ProjectMemosPage as ProjectMemos }
